// Bubble Effect Component - Performance-optimiert mit erweiterten Parametern
import React, { useRef, useEffect, memo } from 'react';
import { DevicePerformance } from '../../utils/performance.js';

export const BubbleEffect = memo(function BubbleEffect({ intensity = 30, effectConfig = {} }) {
  const containerRef = useRef(null);
  
  useEffect(() => {
    if (!containerRef.current) return;
    
    const container = containerRef.current;
    container.innerHTML = '';
    
    if (DevicePerformance.prefersReducedMotion) return;
    
    const count = DevicePerformance.getIntensity(Math.floor(intensity * 0.4));
    if (count === 0) return;
    
    // Effekt-Konfiguration aus Settings
    const speed = effectConfig.speed || 50;
    const direction = effectConfig.direction || 'down';
    const randomness = effectConfig.randomness || 30;
    const customIcon = effectConfig.customIconUrl;
    const manualIcon = effectConfig.manualIcon;
    
    // Icon-Mapping
    const iconMap = {
      snowflake: '❄️',
      bubble: '🫧',
      heart: '❤️',
      star: '⭐',
      sparkle: '✨',
      confetti: '🎉',
      leaf: '🍂',
      flower: '🌸',
      sun: '☀️',
      moon: '🌙',
    };
    
    const fragment = document.createDocumentFragment();
    
    for (let i = 0; i < count; i++) {
      const bubble = document.createElement('div');
      bubble.className = 'bubble';
      
      // Custom Icon oder Standard
      if (manualIcon === 'custom' && customIcon) {
        const img = document.createElement('img');
        img.src = customIcon;
        img.alt = '';
        img.style.cssText = 'width: 100%; height: 100%; object-fit: contain;';
        bubble.appendChild(img);
        bubble.style.background = 'transparent';
      } else if (manualIcon && iconMap[manualIcon]) {
        bubble.textContent = iconMap[manualIcon];
        bubble.style.background = 'transparent';
        bubble.style.display = 'flex';
        bubble.style.alignItems = 'center';
        bubble.style.justifyContent = 'center';
        bubble.style.fontSize = '20px';
      }
      
      const size = 10 + Math.random() * 25;
      const baseSpeed = 10 + Math.random() * 6;
      const adjustedSpeed = baseSpeed * (100 / speed);
      const randomOffset = (Math.random() - 0.5) * (randomness / 10);
      
      // Richtung anpassen
      let animationName = 'bubble-rise';
      if (direction === 'down') animationName = 'bubble-fall';
      if (direction === 'left') animationName = 'bubble-drift-left';
      if (direction === 'right') animationName = 'bubble-drift-right';
      
      bubble.style.cssText += `
        width: ${size}px;
        height: ${size}px;
        left: ${Math.random() * 100}%;
        animation: ${animationName} ${adjustedSpeed}s ease-in-out infinite;
        animation-delay: ${Math.random() * 4}s;
        transform: translateX(${randomOffset}px);
      `;
      fragment.appendChild(bubble);
    }
    
    container.appendChild(fragment);
    
    return () => { container.innerHTML = ''; };
  }, [intensity, effectConfig]);
  
  return <div ref={containerRef} className="bubble-container" aria-hidden="true" />;
});
